/**
 *  Filename ....: match.component.ts
 *  Created by ..: ianday
 *  on Date .....: 11/14/23
 **/
import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ServiceRequest} from "../../../../models/service.request";
import {AgenciesService} from "../../../../services/agencies.service";
import {Settings} from "../../../../services/settings";
import {Agencies} from "../../../../models/agencies";
import {MatTableDataSource} from "@angular/material/table";
import {ServiceRequestsService} from "../../../../services/service-requests.service";
import {TransactionHistoryService} from "../../../../services/transactionhistory.service";
import {AgencyResponse} from "../../../../models/agency-response";

class DataRecord {
    id: number;
    agencyName: string;
    collaborationStatus: string;
    select: boolean;

    constructor(id: number, agencyName:string, collaborationStatus: string, select:boolean) {
        this.id = id;
        this.agencyName = agencyName;
        this.collaborationStatus = collaborationStatus;
        this.select = select;
    }
}
@Component({
    selector: 'app-collaborate-req',
    templateUrl: './collaborate-request.component.html',
    styleUrls: ['./collaborate-request.component.css']
})

export class CollaborateRequestComponent implements OnInit {

    public _requestStatusList: any;
    public _serviceRequest: ServiceRequest;
    public strErr: string | null = '';

    public currentAgency:string;
    public selectedAgency: Agencies;
    public selectedRecord: any;
    public agencyServicesList: any;

    public dataSource: MatTableDataSource<any>;
    public Idx: number = -1;

    public collaborationRequest: number = 0;
    public itemSelected: boolean = false;

    public alreadySelected: any;
    public agencyResponses: Array<AgencyResponse>;
    public displayedColumns = ['id', 'select', 'agencyName', 'collaborationStatus'];

    public showCollaborators: boolean = false;
    public enableWritePermission: boolean = false;
    

    @Output() cancelClicked = new EventEmitter();
    @Output() submitClicked = new EventEmitter<any>();

    @Input() set serviceRequest(val: any) {
        this._serviceRequest = val;
    }
    public get serviceRequest():ServiceRequest {
        return this._serviceRequest;
    }

    constructor(public agencyService:AgenciesService, public serviceRequestService:ServiceRequestsService,
                public txService:TransactionHistoryService) {
    }

    ngOnInit() {

    }

    public doInitialize(ag:Agencies, selectedAgencies: any):void {
        this.currentAgency = ag.agencyName;
        this.alreadySelected = selectedAgencies;
        this.showCollaborators = Settings.getInstance().hasPrivilege('PRIMARY_AGENCY_VIEW_REQUEST_COLLABORATION', 'READ');
        this.enableWritePermission = Settings.getInstance().hasPrivilege('PRIMARY_AGENCY_VIEW_REQUEST_COLLABORATION', 'WRITE');
        if(!this.enableWritePermission){
            this.displayedColumns = ['id', 'agencyName', 'collaborationStatus'];
        } else{
            this.displayedColumns = ['id', 'select', 'agencyName', 'collaborationStatus'];
        }
        if(this.showCollaborators){
            this.loadQualifyingAgencies();
        }
    }

    public loadQualifyingAgencies():void {

        this.agencyServicesList = new Array();
        this.strErr = '';
      //  this.broadcastFlag = false;

        if(this.serviceRequest.zipCode.length === 0) {
            this.strErr = 'Error: no zip-code present - please add one in the case tab before attempting a collaborate';
            return;
        }

        this.agencyService.getQualifyingAgenciesForCollaboration(this.serviceRequest.id,
            this.serviceRequest.serviceRequestTypeId, this.serviceRequest.zipCode).subscribe(
            (results) => {
                this.agencyServicesList = new Array();

                const localIdx = results.findIndex(i => i.id === this.serviceRequest.agencyId);

                /**  peel off the existing agency record - so it doesn't appear for selection again. **/
                if ((localIdx !== null ) && (localIdx > -1)) {
                    results.splice(localIdx, 1);
                }
                /** now loop through the rest of the records ***/
                for(let rec of results) {

                    /** if the agency is already on the list then just skip it. **/
                    if(this.alreadySelected.findIndex(s => s.agencyId === rec.id) > -1) {
                        continue;
                    }

                    let d: DataRecord;
                    let selected = false;
                    if(rec.collaborationStatus === null) {
                        rec.collaborationStatus = 'Not Selected';
                    }
                    else {
                        selected = true;
                    }
                    d = new DataRecord(rec.id, rec.agencyName, rec.collaborationStatus, selected);
                    this.agencyServicesList.push(d);
                }

                this.dataSource = new MatTableDataSource(this.agencyServicesList);

                /*** test for the broadcast flag i ***/
           //     if(this.serviceRequest.collaborationRequest ===1) {
           //         this.broadcastFlag = true;
            //    }
            },
            (error) => {
                Settings.getInstance().handleError(error, 'getting agencies');
            });
    }
    public tableKeyDown(event: KeyboardEvent) {

        const len: number = this.dataSource.filteredData.length;
        if (event.key === 'ArrowDown') {
            if (this.Idx < (len - 1)) {
                this.selectedRecord = this.dataSource.filteredData[++this.Idx];

            }
        } else if (event.key === 'ArrowUp') {
            if (this.Idx > 0) {
                this.selectedRecord = this.dataSource.filteredData[--this.Idx];

            }
        }
        else if(event.key === 'Enter') {
            this.selectedRecord = this.dataSource.filteredData[this.Idx];
            this.onSubmitClicked();             // just select it!
        }
    }
    public onRowClicked(row:any): void {
        /*this.selectedRecord = row;
        this.Idx = this.dataSource.connect().value.indexOf(this.selectedRecord);
      */
    }
    public checkAgency(event:any, idx:number): void {

        if(event.checked === true ) {
            this.dataSource.data[idx].collaborationStatus = 'Requested';
        }
        else if(event.checked === false) {
            this.dataSource.data[idx].collaborationStatus = 'Not Selected';
        }

        if(this.dataSource.filteredData.filter(s => s.select === true).length > 0) {
            this.itemSelected = true;
        }
        else {
            this.itemSelected = false;
        }

       // if(this.dataSource.data.filter(s => s.select === true).length > 0) {
       //     this.broadcastFlag = false;
       // }
    }
    public doUnAssignCheckBoxChange(event:any): void {

        if(event.checked === true) {

            this.Idx = -1;

            // uncheck the agencies
            for(let i = 0; i < this.dataSource.data.length;i++) {
                this.dataSource.data[i].select = false;
            }
        }
        else {
            this.checkAgency(null, null);
        }
    }
    public setRecordsForUpdate():void {

        this.agencyResponses = new Array<AgencyResponse>();
        this.collaborationRequest = 0;

        for(let rec of this.dataSource.data) {
            if(rec.select === true) {
                let ar = new AgencyResponse().setNewAgencyResponseRecord(this.serviceRequest.id, rec.id, this.serviceRequest.unitOfMeasure);
                ar.plannedCommitted = 'Requested'
                this.agencyResponses.push(ar);
            }
        }
    }
    public onSubmitClicked():void {

        this.setRecordsForUpdate();
        /** persist will happen in the approval dialog **/
        this.submitClicked.emit(this.agencyResponses);
    }

    public onCancelClicked(): void {
        this.cancelClicked.emit();
    }
    /*** colors ***/
    public getStatusColors(statusVal:string) : string {

        if(statusVal === undefined) {
            return '';
        }

        switch(statusVal) {
            case 'Requested':
                return 'orange';
            case 'Denied':
                return 'darkred';
            case 'Approved':
                return 'green';
            case 'Not Selected':
                return 'gray';
        }
        return '';
    }
}

